import styled, {css} from 'styled-components';
import {LabelSelectedDatesProps} from './LabelSelectedDates.types';

const LabelSelectedDatesWrapper = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	gap: 6px;
	margin-bottom: 8px;
`;

const LabelSelectedDatesLabel = styled.span<LabelSelectedDatesProps>`
	font-size: 18px;
	font-weight: 600;
	line-height: 27px;
	letter-spacing: 0.15px;

	${({theme}) => css`
		color: ${theme.colors.light.text.secondary};
	`}

	${({theme, firstDaySelected, secondDaySelected}) =>
		(firstDaySelected || secondDaySelected) &&
		css`
			color: ${theme.colors.light.text.primary};
		`}
`;

const LabelSelectedDatesOptional = styled.span`
	font-size: 14px;
	font-weight: 400;
	line-height: 21px;
	letter-spacing: 0.15px;
	${({theme}) => css`
		color: ${theme.colors.light.text.secondary};
	`}
`;

export {LabelSelectedDatesWrapper, LabelSelectedDatesLabel, LabelSelectedDatesOptional};
